<div
  class="ids-card -primary -no-border -hover card_oportunidade"
  (click)="buttonEvent.emit()"
  role="button"
  [attr.aria-label]="accessible_text"
>
  <ids-icon contrast="dark" size="L">
    {{ icon }}
  </ids-icon>
  <span class="text">{{ title }}</span>
</div>
